/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExportRequestTransactionOntology } from '../../models/export-request-transaction-ontology';

export interface GetExportRequestTransactionOntology$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected ontology
 */
  ontologyUid: string;
}

export function getExportRequestTransactionOntology(http: HttpClient, rootUrl: string, params: GetExportRequestTransactionOntology$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestTransactionOntology>> {
  const rb = new RequestBuilder(rootUrl, getExportRequestTransactionOntology.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('ontologyUid', params.ontologyUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExportRequestTransactionOntology>;
    })
  );
}

getExportRequestTransactionOntology.PATH = '/export-request/{uid}/ontology/transaction/{ontologyUid}';
